import Vue from 'vue'
import Vuex from 'vuex'
import quote from './modules/quote';
import BusinessList from '../views/BusinessList.vue';

Vue.use(Vuex);

const state = {
    occupationList: [],
    businessList: [],
    flowId: '',
    cityList: [],
    cityGroup: [],
    minuteList: [
        '00',
        '01',
        '02',
        '03',
        '04',
        '05',
        '06',
        '07',
        '08',
        '09',
        '10',
        '11',
        '12',
        '13',
        '14',
        '15',
        '16',
        '17',
        '18',
        '19',
        '20',
        '21',
        '22',
        '23',
        '24',
        '25',
        '26',
        '27',
        '28',
        '29',
        '30',
        '31',
        '32',
        '33',
        '34',
        '35',
        '36',
        '37',
        '38',
        '39',
        '40',
        '41',
        '42',
        '43',
        '44',
        '45',
        '46',
        '47',
        '48',
        '49',
        '50',
        '51',
        '52',
        '53',
        '54',
        '55',
        '56',
        '57',
        '58',
        '59'
    ],
    flowId: '',
    isNewCar: false,
    insuredTips: '',
    applicantTips: '',
    deptCode: '',
    showKB: false,
    licenseKB: '',
    userInfo: {},
    carInfo: {},
    isStartVideo: false,
    isSdjg: false
};

const getters = {
    getShowKB(state) {
        return state.showKB;
    },
    getLicenseKB(state) {
        return state.licenseKB;
    },

}

const mutations = {
    setOccupationList(state, occupationList) {
        state.occupationList = occupationList;
    },
    setBusinessList(state, businessList) {
        state.businessList = businessList;
    },
    setCityList(state, cityList) {
        state.cityList = cityList;
    },
    setCityGroup(state, cityGroup) {
        state.cityGroup = cityGroup;
    },
    setFlowId(state, flowId) {
        state.flowId = flowId;
    },
    setNewCar(state, isNewCar) {
        state.isNewCar = isNewCar;
    },
    setInsuredTips(state, insuredTips) {
        state.insuredTips = insuredTips;
    },
    setApplicantTips(state, applicantTips) {
        state.applicantTips = applicantTips;
    },
    setHolderMsg(state, insuredTips) {
        // debugger;
        // state.insuredTips = insuredTips;
    },
    setDeptCode(state, deptCode) {
        state.deptCode = deptCode;
    },
    openKB(state) {
        state.showKB = true;
    },
    hideKB(state) {
        state.showKB = false;
        window.sessionStorage.setItem('carCache', state.quote.quoteInfo.vehicle.licenseNo);
    },
    setLicenseKB(state, licenseKB) {
        state.licenseKB = licenseKB;
    },
    setUserInfo(state, info) {
        state.userInfo = info;
    },
    setCarInfo(state, info) {
        state.carInfo = info;
    },
    setIsStartVideo(state, isStartVideoflag) {
        state.isStartVideo = isStartVideoflag;
    },
    setIsHc(state, isHc) {
        state.isHc = isHc;
    },
    // 是否需要展示功率录入框
    setPowerInput(state, powerInput) {
        state.powerInput = powerInput;
    },
    setSdjg(state, isSdjg) {
      state.isSdjg = isSdjg
    }
}

const actions = {};


export default new Vuex.Store({
    modules: {quote},
    state,
    getters,
    mutations,
    actions,
});